import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BASKET_API_TOKEN } from '@epicuro-next/data/baskets';

@Injectable()
export class PendingBasketsAlertService {
  constructor(
    private httpClient: HttpClient,
    @Inject(BASKET_API_TOKEN) private basketApiUrl: string,
  ) {
    if (!basketApiUrl)
      throw new Error('BASKET_V1_API_TOKEN token not provided');
  }

  public checkPendingBaskets() {
    return this.httpClient.get<string[]>(
      `${this.basketApiUrl}/ready-for-review`,
    );
  }
}
